// @ts-nocheck
/* Port of ReleaseSkeleton.js (17L). BYTE-IDENTICAL. */
import React from 'react';

const ReleaseSkeleton = ({ count = 3 }: any) => (
  <div aria-hidden="true">
    {Array.from({ length: count }).map((_, i) => (
      <div className="rc-skeleton" key={i}>
        <div className="rc-sk-line" style={{ width: '30%' }} />
        <div className="rc-sk-line" style={{ width: '70%', height: 20 }} />
        <div className="rc-sk-line" style={{ width: '90%' }} />
        <div className="rc-sk-line" style={{ width: '55%' }} />
      </div>
    ))}
  </div>
);

export default ReleaseSkeleton;
